import React from 'react'
import ReactDOM from 'react-dom'
import Iframe from './Iframe'

ReactDOM.render(<Iframe />, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js